import React from 'react';
import './index.css';

const Card = ({ title, onClick, selected }) => {
  return (
    <div
      className={`card ${selected ? 'selected' : ''}`}
      onClick={onClick}
    >
      <h2>{title}</h2>
    </div>
  );
};

export default Card;
